// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__HmC6N","rise":"Toast_rise__XUj3m"};